import $ from 'jquery';
import state from 'state';

var $window = $(window),
    panels = $('.scrollPanel');

export function setup(p) {
    var w = $('body'),
        cont = $('.content', p),
        go = function go(x, f) {
            state.map.closePopup();
            w.stop();
            p.stop();
            w.animate({ scrollLeft: 0 }, 'fast');
            p.animate({ width: x }, 'fast', function () {
                p.css('overflow', '');
                if (typeof f == 'function')
                    f();
            });
        };
    p.open = function () {
        p.triggerSafe('preOpen');
        panels.removeClass('selected');
        p.addClass('selected');
        var width = Math.min(280, $window.width() - 60);
        cont.css('width', width + 'px');
        go(width + 20, function () {
            p.triggerSafe('afterOpen');
        });
    };
    p.close = function () {
        go(0);
        $('#map').focus(); // global hotkeys
    };
    p.isOpen = function () {
        return (w.scrollLeft() > 0) || (parseInt(p.css('width'), 10) > 0);
    };
    p.toggleOpen = function () {
        if (p.isOpen())
            p.close();
        else
            p.open();
    };
    p.keyup(function (e) {
        if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey)
            return;
        if (e.which == 27) { // Escape closes the panel
            e.preventDefault();
            p.close();
        }
    });
    $('area', p).click(function (e) {
        e.preventDefault();
        p.toggleOpen();
    });
}
